import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('cloudcost_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor to handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear token and redirect to login
      localStorage.removeItem('cloudcost_token');
      // Only redirect if not already on login page
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

// Costs API
export const getCostsSummary = () => api.get('/costs/summary');
export const getProviderCosts = (provider, days = 30) => api.get(`/costs/provider/${provider}?days=${days}`);
export const getCostsComparison = () => api.get('/costs/comparison');
export const getCostsServices = (months = 1) => api.get(`/costs/services?months=${months}`);
export const getCostsServicesDetails = (months = 1) => api.get(`/costs/services/details?months=${months}`);
export const refreshCosts = () => api.post('/costs/refresh');

// Providers API
export const getProviders = () => api.get('/providers');
export const getProvider = (id) => api.get(`/providers/${id}`);
export const updateProvider = (id, data) => api.put(`/providers/${id}`, data);
export const connectProvider = (id) => api.post(`/providers/${id}/connect`);
export const disconnectProvider = (id) => api.post(`/providers/${id}/disconnect`);
export const syncProvider = (id) => api.post(`/providers/${id}/sync`);
export const syncAllProviders = () => api.post('/providers/sync-all');
export const getSyncHistory = (limit = 50) => api.get('/providers/sync-history?limit=' + limit);

// Alerts API
export const getAlerts = () => api.get('/alerts');
export const createAlert = (data) => api.post('/alerts', data);
export const updateAlert = (id, data) => api.put(`/alerts/${id}`, data);
export const deleteAlert = (id) => api.delete(`/alerts/${id}`);
export const testAlertEmail = (id) => api.post(`/alerts/test-email/${id}`);

// Settings API
export const getRefreshSettings = () => api.get('/settings/refresh');
export const updateRefreshSettings = (data) => api.put('/settings/refresh', data);
export const getSmtpSettings = () => api.get('/settings/smtp');
export const updateSmtpSettings = (data) => api.put('/settings/smtp', data);
export const testSmtpConnection = () => api.post('/settings/smtp/test');

// Users API (Admin)
export const getUsers = () => api.get('/users');
export const createUser = (data) => api.post('/users', data);
export const deleteUser = (id) => api.delete(`/users/${id}`);
export const updateUserRole = (id, role) => api.put(`/users/${id}/role?role=${role}`);
export const getAzureDirectoryUsers = () => api.get('/users/azure-directory');
export const importAzureUser = (data) => api.post('/users/import', data);

// Export API
export const exportCSV = () => api.get('/export/csv');
export const exportJSON = () => api.get('/export/json');

export default api;
